import { Helmet } from "react-helmet";
import Logo from "../imgs/Logo.png";
function Head({ title }) {
  return (
    <Helmet>
      <title>LINKER {title ? `- ${title}` : ""}</title>
      <link rel="icon" type="images/png" href={Logo} />
    
    </Helmet>
  );
}

export default Head;
